import { render } from "./eventTerms.vue?vue&type=template&id=a12b4280&scoped=true&ts=true"
import script from "./eventTerms.vue?vue&type=script&lang=ts&config=true"
export * from "./eventTerms.vue?vue&type=script&lang=ts&config=true"

import "./eventTerms.vue?vue&type=style&index=0&id=a12b4280&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12b4280"]])

export default __exports__